module.exports = __webpack_public_path__ + "img/activate-pdf-voucher-fr2.d0030d0f.png";